import { caseFilterhash } from '@debbie/common/dist/insights/index.js';
import { setFetchStartState } from '../fetchLoadable.js';
import { selectedCreditorId } from '../internal.js';
import * as actionTypes from './actionTypes.js';
import * as selecterOwnersActionTypes from '../selectedOwners/actionTypes.js';
import { getFilterFromLocalStorage } from './localStorage.js';
export const caseFilterReducer = (state = {
    creditorIds: selectedCreditorId ? [selectedCreditorId] : [],
}, action) => {
    switch (action.type) {
        case actionTypes.SET_SELECTED_CREDITORS:
            return {
                ...state,
                creditorIds: action.payload.creditors,
            };
        case actionTypes.UPDATE_FILTER:
            return {
                ...state,
                ...action.payload.filter,
            };
        case actionTypes.CLEAR_FILTER: {
            const { filterName, isDate, dateField } = action.payload;
            if (filterName === 'creditorIds') {
                return {
                    ...state,
                    creditorIds: [],
                };
            }
            const newState = { ...state };
            // @ts-ignore
            const filter = newState[filterName];
            if (isDate) {
                if (filter[dateField] && Object.keys(filter).length > 0) {
                    delete filter[dateField];
                }
                if (Object.keys(filter).length === 0) {
                    // @ts-ignore
                    delete newState[filterName];
                }
                return newState;
            }
            // @ts-ignore
            delete newState[filterName];
            return newState;
        }
        case selecterOwnersActionTypes.SELECT_OWNERS: {
            const savedFilter = getFilterFromLocalStorage(action.payload.selected);
            if (!selectedCreditorId) {
                return savedFilter;
            }
            return state;
        }
        default:
            return state;
    }
};
export const caseFilterCountReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_CASE_FILTER_COUNT_START:
            return {
                ...state,
                [caseFilterhash(payload.caseFilter)]: {
                    ...setFetchStartState(state[caseFilterhash(payload.caseFilter)], payload.res),
                },
            };
        case actionTypes.FETCH_CASE_FILTER_COUNT_SUCCESS:
        case actionTypes.FETCH_CASE_FILTER_COUNT_ERROR:
            return {
                ...state,
                [caseFilterhash(payload.caseFilter)]: { ...payload.res },
            };
        default:
            return state;
    }
};
export const caseFilterQueueReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map